import _ from 'lodash'
import config from '../../config'
import fetch from '../../lib/wrappedFetch'

class CustomerRelationshipsService {
  followCustomer = (params) => {
    return fetch(config.config.endpointUrls.followCustomer(params), {
      method: 'POST'
    })
  }
  unfollowCustomer = (params) => {
    return fetch(config.config.endpointUrls.unfollowCustomer(params), {
      method: 'POST'
    })
  }
}

export default new CustomerRelationshipsService()


// WEBPACK FOOTER //
// ../src/services/customerRelationshipsService/customerRelationshipsService.js